<template>
  <vuex-table :fields="fields" :auto_start="false" table_store="mailer/messages/table" />
</template>

<script>
  export default {
    computed: {
      fields: function() {
        return [
          {
            key: 'src',
            label: this.$t('mailer.message.field.src'),
            sortable: false,
            class: 'w-25'
          },
          {
            key: 'dst',
            label: this.$t('mailer.message.field.dst'),
            sortable: false,
            class: 'w-25'
          },
          {
            key: 'body',
            label: this.$t('mailer.message.field.body'),
            sortable: false,
            class: 'w-25'
          },
          {
            key: 'created_at',
            label: this.$t('mailer.message.field.created_at'),
            sortable: true,
            class: 'w-25'
          }
        ];
      }
    }
  };
</script>
